import debounce from "lodash/debounce";
import PropTypes from "prop-types";
import { createElement, forwardRef, useCallback } from "react";
// import styled from "styled-components";

// import { Input } from './input';

const noop = () => {};

export const Button = forwardRef(function Button(
  {
    /* component props */
    children,
    className,
    /* lodash debounce arguments */
    wait = 500,
    leading = true,
    maxWait = 500,
    trailing = false,
    /* synthetic events */
    onClick = noop,
    /* input attributes */
    autoFocus,
    autoComplete = "off", // FF-specific quirk https://bugzilla.mozilla.org/show_bug.cgi?id=654072
    disabled = false,
    form,
    formAction,
    formEncType,
    formMethod,
    formNoValidate,
    formTarget,
    name,
    type = "button",
  },
  ref
) {
  const debouncedOnClick = useCallback(
    debounce(onClick, wait, {
      leading,
      trailing,
      maxWait,
    }),
    [onClick]
  );
  return createElement(
    "button",
    {
      /* component props */
      className,
      /* synthetic events */
      onClick: disabled ? noop : debouncedOnClick,
      /* input attributes */
      autoFocus,
      autoComplete,
      disabled,
      form,
      formAction,
      formEncType,
      formMethod,
      formNoValidate,
      formTarget,
      name,
      ref,
      type,
    },
    children
  );
});

Button.propTypes = {
  /* component props */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
  className: PropTypes.string,
  /* lodash debounce arguments */
  wait: PropTypes.number,
  leading: PropTypes.bool,
  maxWait: PropTypes.number,
  trailing: PropTypes.bool,
  /* synthetic events */
  onClick: PropTypes.func,
  /* input attributes */
  autoFocus: PropTypes.bool,
  autoComplete: PropTypes.oneOf(["off"]), // FF-specific quirk
  disabled: PropTypes.bool,
  form: PropTypes.string,
  formAction: PropTypes.string,
  formEncType: PropTypes.oneOf([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain",
  ]),
  formMethod: PropTypes.oneOf(["post", "get", "dialog"]),
  formNoValidate: PropTypes.bool,
  formTarget: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["button", "submit"]).isRequired,
};
